import { ReactElement } from 'react';
import { ModalProps, Modal } from '@Calix-Commerce/design-system/components';

export type SingleActionModalProps = Omit<Omit<ModalProps, 'title'>, 'content'> & {
  onConfirmation: () => void;
  title: string;
  content: string;
  confirmButtonText: string;
  isOpen: boolean;
};

const SingleActionModal = ({
  onConfirmation,
  title,
  content,
  confirmButtonText,
  isOpen,
  ...props
}: SingleActionModalProps): ReactElement => {
  return (
    <Modal
      title={title}
      isOpen={isOpen}
      content={content}
      confirmButtonText={confirmButtonText}
      onConfirmation={onConfirmation}
      {...props}
    />
  );
};

export { SingleActionModal };
